import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const BrandCtx = createContext(null);

/** brand: "ai" | "media" — auto-derived from route, overridable via setBrand. */
export function BrandProvider({ children }) {
  const [brand, setBrand] = useState("ai");
  const loc = useLocation();

  useEffect(() => {
    if (loc.pathname.startsWith("/studio") || loc.pathname.startsWith("/media")) {
      setBrand("media");
    } else if (loc.pathname.startsWith("/academy")) {
      setBrand("ai");
    }
  }, [loc.pathname]);

  return (
    <BrandCtx.Provider value={{ brand, setBrand }}>{children}</BrandCtx.Provider>
  );
}

export const useBrand = () => useContext(BrandCtx);
